import { gql } from '__generated__';

export default gql(`
  query GetEInvoicingRecipients($input: EInvoicingRecipientsInput!) {
    eInvoicingRecipients(input: $input) {
      address
      name
      country
    }
  }
`);
